export enum LoginType {
  PASSWORD = 'PASSWORD',
  SMS_CODE = 'SMS_CODE',
}

export const LoginTypeMap = {
  [LoginType.PASSWORD]: '密码',
  [LoginType.SMS_CODE]: '短信验证码',
};

export const LoginTypeOptions = Object.keys(LoginType).map((key) => ({
  value: LoginType[key as keyof typeof LoginType],
  label: LoginTypeMap[LoginType[key as keyof typeof LoginType]],
}));
